import { render, staticRenderFns } from "./BarFavoriteComponent.vue?vue&type=template&id=4e1c0310&"
import script from "./BarFavoriteComponent.vue?vue&type=script&lang=js&"
export * from "./BarFavoriteComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports